<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import mvtCheckbox from '@/common/components/mvtcheckbox/mvt-checkbox.vue';
import mvtRadio from '@/common/components/mvtradio/mvt-radio.vue';
import mvtToggleSwitch from '@/common/components/mvttoggleswitch/mvt-toggle-switch.vue';

export default {
  name: 'mvtMapLayers',
  inject: ['$eventBus'],
  props: {
    activeLayer: {
      type: String || null,
    },
    activeMapType: {
      type: String || null,
    },
    changeMapLayer: {
      type: Function,
    },
    changeMapType: {
      type: Function,
    },
    getSchoolPins: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      /* New */
      active: false,
      /* Legacy */
      showSchoolFilter: false,
      schoolUnrated: [
        {
          text: ' Include N/A rating',
          value: 1,
          defaultValue: 0
        }
      ],
      scoreList: [
        {
          text: '1+',
          value: 1,
        },
        {
          text: '2+',
          value: 2,
        },
        {
          text: '3+',
          value: 3,
        },
        {
          text: '4+',
          value: 4,
        },
        {
          text: '5+',
          value: 5,
        },
        {
          text: '6+',
          value: 6,
        },
        {
          text: '7+',
          value: 7,
        },
        {
          text: '8+',
          value: 8,
        },
        {
          text: '9+',
          value: 9,
        },
        {
          text: '10',
          value: 10,
        },

      ]
    };
  },
  components: {
    mvtCheckbox,
    mvtRadio,
    mvtToggleSwitch,
  },
  computed: {
    ...mapGetters('glb', ['glb', 'mapType', 'mapDetails', 'getSelectedPoi']),
    ...mapGetters('msp', ['msp']),
    schoolHigh: {
      set: function (val) {
        this._updateFilterByKey(val, 'schoolHigh');
      },
      get: function () {
        return this.msp.filter.schoolHigh;
      }
    },
    schoolMiddle: {
      set: function (val) {
        this._updateFilterByKey(val, 'schoolMiddle');
      },
      get: function () {
        return this.msp.filter.schoolMiddle;
      }
    },
    schoolPre: {
      set: function (val) {
        this._applyFilter({
          schoolPre: val,
          schoolElementary: val
        });
      },
      get: function () {
        return this.msp.filter.schoolPre;
      }
    },
    schoolPublic: {
      set: function (val) {
        this._updateFilterByKey(val, 'schoolPublic');
      },
      get: function () {
        return this.msp.filter.schoolPublic;
      }
    },
    schoolCharter: {
      set: function (val) {
        this._updateFilterByKey(val, 'schoolCharter');
      },
      get: function () {
        return this.msp.filter.schoolCharter;
      }
    },
    schoolPrivate: {
      set: function (val) {
        this._updateFilterByKey(val, 'schoolPrivate');
      },
      get: function () {
        return this.msp.filter.schoolPrivate;
      }
    },
    schoolMinRate: {
      set: function (val) {
        this._updateFilterByKey(val, 'schoolMinRate');
      },
      get: function () {
        return this.msp.filter.schoolMinRate;
      }
    },
    schoolIncludeUnrated: {
      set: function (val) {
        this._updateFilterByKey(val, 'schoolIncludeUnrated');
      },
      get: function () {
        return this.msp.filter.schoolIncludeUnrated;
      }
    }
  },
  methods: {
    ...mapActions('msp', ['applyFilterData']),
    ...mapMutations('glb', ['updateMapType', 'updateMapDetails', 'updateSelectedPoi']),
    setActive(isActive) {
      if(isActive !== undefined) {
        this.active = isActive;
      } else {
        this.active = !this.active;
      }
      if (this.active) {
        // Add event listener when the card becomes visible
        document.addEventListener('click', this.handleClickOutside);
      } else {
        // Remove event listener when the card is hidden
        document.removeEventListener('click', this.handleClickOutside);
      }

    },
    toggleMapSchools() {
      this.showSchoolFilter = !this.showSchoolFilter;
      if (!this.showSchoolFilter) {
        this._applyFilter({
          schoolPre: 0,
          schoolElementary: 0,
          schoolMiddle: 0,
          schoolHigh: 0,
          schoolPublic: 0,
          schoolCharter: 0,
          schoolPrivate: 0
        });
      } else {
        this._applyFilter({
          schoolPublic: 1
        });
      }
    },
    schoolFilter(filterType) {
      this[filterType] = Math.abs(this[filterType] - 1);
      let filterData = {};
      filterData[filterType] = this[filterType];
      this._applyFilter(filterData);
    },
    async _applyFilter(data) {
      const that = this;
      this.applyFilterData(data).then(url => {
        if (window.location.pathname !== url) {
          if (that.getSchoolPins) {
            that.$emit('updateSchoolsOnMap', url);
          } else {
            that.$router.push(url);
          }
        }
      });
    },
    _updateFilterByKey(context, key) {
      var param = {};
      param[key] = context && context.value || context;
      param && this._applyFilter(param);
    },
    updatePoi(poi) {
      let selectedPoiList = this.getSelectedPoi.includes(poi) ? this.getSelectedPoi.filter(selectedPoi => selectedPoi !== poi) : [...this.getSelectedPoi, poi];
      this.updateSelectedPoi(selectedPoiList);
    },
    /* Layers */
    updateMapLayer(layer) {
      if(layer === this.activeLayer) {
        this.changeMapLayer(null);
      } else {
        this.changeMapLayer(layer);
      }
    },
    /* TODO
      See what the following methods produce:
      ['updateMapType', 'updateMapDetails', 'updateSelectedPoi']
    */
    handleClickOutside(event) {
      // Check if the click is outside the dropdown
      if (this.$refs.panelRef && !this.$refs.panelRef.contains(event.target)) {
        this.active = false;
        // Remove event listener after hiding the dropdown
        document.removeEventListener('click', this.handleClickOutside);
      }
    },
  },
  beforeUnmount() {
    // Remove event listener to avoid memory leaks
    document.removeEventListener('click', this.handleClickOutside);
  },
};
</script>

<template>
  <div class="mvt-newmapoptions" ref="panelRef">
    <button type="button" class="btn secondary small" @click="() => { setActive() }">
      <i class="icon-double-layer"></i>
      <span>Options</span>
    </button>
    <div class="layer-content" v-if="active">
      <button type="button" class="mvt-maplayers-close" @click="() => { setActive(false) }"></button>
      <div class="grid xs-grid-cols-1" >
        <div class="grid xs-grid-cols-3 gap-1">
          <span class="wrap text-bold">Map Type</span>
          <a class="btn toggle small" @click="changeMapType('activeMap')"
             :class="{'active': activeMapType === 'roadmap' || activeMapType === 'activeMap'}">Map</a>
          <a class="btn toggle small" @click="changeMapType('satellite')"
             :class="{'active': activeMapType === 'satellite'}">Satellite</a>
          <a class="btn toggle small" @click="changeMapType('terrain')" :class="{'active': activeMapType === 'terrain'}">Terrain</a>
        </div>
        <div class="grid xs-grid-cols-3 gap-1">
          <span class="wrap text-bold">Map Details</span>
          <a role="button" class="btn toggle small" @click="updateMapLayer('traffic')"
             :class="{'active': activeLayer === 'traffic'}">
            <i class="icon-car"></i>
            <span>Traffic</span>
          </a>
          <a role="button" class="btn toggle small" @click="updateMapLayer('transit')"
             :class="{'active': activeLayer === 'transit'}">
            <i class="icon-poi-train"></i>
            <span>Transit</span>
          </a>
          <a role="button" class="btn toggle small" @click="updateMapLayer('biking')"
             :class="{'active': activeLayer === 'biking'}">
            <i class="icon-bicycle"></i>
            <span>Biking</span>
          </a>
        </div>
        <div class="grid xs-grid-cols-2 gap-1">
          <span class="wrap text-bold">Nearby Places</span>
          <a role="button" class="btn toggle small" @click="updatePoi('grocery')"
             :class="{'active': getSelectedPoi.includes('grocery')}">
            <i class="icon-poi-grocery"></i>
            <span>Groceries</span>
          </a>
          <a role="button" class="btn toggle small" @click="updatePoi('cafes')"
             :class="{'active': getSelectedPoi.includes('cafes')}">
            <i class="icon-coffee"></i>
            <span>Cafes</span>
          </a>
          <a role="button" class="btn toggle small" @click="updatePoi('restaurants')"
             :class="{'active': getSelectedPoi.includes('restaurants')}">
            <i class="icon-poi-eat"></i>
            <span>Restaurants</span>
          </a>
          <a role="button" class="btn toggle small" @click="updatePoi('parks')"
             :class="{'active': getSelectedPoi.includes('parks')}">
            <i class="icon-park"></i>
            <span>Parks</span>
          </a>
          <a role="button" class="btn toggle small" @click="updatePoi('shopping')"
             :class="{'active': getSelectedPoi.includes('shopping')}">
            <i class="icon-poi-shopping"></i>
            <span>Shopping</span>
          </a>
          <a role="button" class="btn toggle small" @click="updatePoi('transits')"
             :class="{'active': getSelectedPoi.includes('transits')}">
            <i class="icon-poi-bus"></i>
            <span>Transit</span>
          </a>
        </div>
        <div class="map-schools grid xs-grid-cols-2 gap-1">
          <div class="wrap flex middle map-schools-toggle-row">
            <span class="text-bold">Schools</span>
            <mvtToggleSwitch
              :model-value="showSchoolFilter"
              @update:model-value="toggleMapSchools"
              aria-label="Show school filters on map"
            />
          </div>
          <template v-if="showSchoolFilter">
            <a role="button" class="btn toggle small" @click="schoolFilter('schoolPre')"
               :class="{'active': schoolPre === 1}">Pre-K & Elementary</a>
            <a role="button" class="btn toggle small" @click="schoolFilter('schoolCharter')"
               :class="{'active': schoolCharter === 1}">Charter</a>
            <a role="button" class="btn toggle small" @click="schoolFilter('schoolMiddle')"
               :class="{'active': schoolMiddle === 1}">Middle</a>
            <a role="button" class="btn toggle small" @click="schoolFilter('schoolPrivate')"
               :class="{'active': schoolPrivate === 1}">Private</a>
            <a role="button" class="btn toggle small" @click="schoolFilter('schoolHigh')"
               :class="{'active': schoolHigh === 1}">High</a>
            <a role="button" class="btn toggle small" @click="schoolFilter('schoolPublic')"
               :class="{'active': schoolPublic === 1}">Public</a>
          </template>
        </div>
        <div v-if="showSchoolFilter" class="grid xs-grid-cols-1 gap-1">
          <div class="flex middle">
            <span class="text-bold">Great Schools Rating</span>
            <mvtCheckbox theme="small" :data="schoolUnrated" v-model="schoolIncludeUnrated"></mvtCheckbox>
          </div>
          <mvtRadio class="grid small xs-grid-cols-5 gap-1 buttons toggle" v-model="schoolMinRate" :data="scoreList"/>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">

@use "~@/common/scss/base/_defined.scss" as *;

.mvt-newmapoptions {
  display: flex;
  flex-direction: column;
  gap: var(--g2);
  >button{
    width: fit-content;
  }
  .layer-content {
    position: relative;
    box-shadow: 0 2px 4px 0 rgba(74,74,74,0.3);
    display: block;
    background-color: var(--color-bg);
    @include f5();
    border-radius: var(--border-radius);
    z-index: 1;
    min-height: 14.2rem;
    max-height: 65vh;
    overflow: auto;
    @include hidden-scrollbar();
    width: fit-content;
    padding: 1rem;
    .mvt-maplayers-close{
      @include f4();
      right: 0;
      top: 0;
      padding: var(--g3);
      position: absolute;
      display: inline-block;
      line-height: var(--line-height-1);
      text-align: center;
      z-index: 3;
      &:after{
        @include fonticon();
        content: $icon-times;
      }
    }
    .radio {
      --radio-width:100%;
    }
    @media screen and (max-width: $screen-xs-max) {
      max-height: 55vh;
    }
  }

  .map-schools{
    .map-schools-toggle-row {
      gap: var(--g1);
      justify-content: space-between;
      width: 100%;
    }
    .school-filter{
      display: flex;
      gap: var(--g1);
      a{
        border: 1px solid var(--color-border);
        text-align: center;
        padding: 0.2rem;
        border-radius: 1.7rem;
        background-color: var(--color-default-bg);

      }
      a:nth-child(odd){
        width: 60%;
      }
      a:nth-child(even){
        width: 40%;
      }
      .active{
        font-weight:var(--font-weight-bold);
        border: 1px solid var(--color-main);
        background-color: var(--color-main-l1);
      }
    }
  }
}

</style>